import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';

export default class ReportErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[Report render error]', error, info);
    this.setState({ info });
  }
  reset = () => this.setState({ error: null, info: null });
  render() {
    if (this.state.error) {
      return (
        <Alert severity="error" action={<Button size="small" onClick={this.reset}>Retry</Button>}>
          <AlertTitle>Report failed to render</AlertTitle>
          <Box component="pre" sx={{ m: 0, whiteSpace: 'pre-wrap', fontSize: 12 }}>
            {String(this.state.error?.message || this.state.error)}
          </Box>
        </Alert>
      );
    }
    return this.props.children;
  }
}
